import { createContext } from "react";
import { PRIMARY_NAVIGATION_STRIP_ICON_VERTICAL_INSET_PX } from "@-/dev.improve.haniverse.lib.primary-navigation-strip.entities";

/** Let live scene content fill the gutter above the icons, beneath the opacity ramp. */
export const PRIMARY_NAVIGATION_STRIP_FADE_INSET_PX =
  PRIMARY_NAVIGATION_STRIP_ICON_VERTICAL_INSET_PX;

/** Scene overlap into the tab row's existing top padding; pinned controls stay above it. */
export const PrimaryNavigationStripFadeInsetContext = createContext(0);
